const client = require('./client')

const state = { searchVersion: 1, saving: false }
let loading = null

function load () {
    if (!loading) {
        loading = client.silent().get(null, '/user/interface-options').then((response) => {
            const data = (response && response.data) || {}
            state.searchVersion = data.search_version === 2 ? 2 : 1
            return Object.assign({}, data, { search_version: state.searchVersion })
        }).catch(() => {
            state.searchVersion = 1
            loading = null
            return { search_version: 1 }
        })
    }
    return loading
}

function searchUrl (draft = false, searchQuery = '') {
    if (state.searchVersion === 2) {
        const base = '/properties/search/new'
        if (searchQuery) return `${base}?q=${encodeURIComponent(searchQuery)}`
        if (!draft) return base
        const query = 'eyJpc01pbmUiOmZhbHNlLCJwb3J0YWwiOnt9LCJub3RPblBvcnRhbHMiOltdLCJub3RTZWxlY3RlZEZvclBvcnRhbHMiOltdLCJub3RQcmVTZWxlY3RlZEZvclBvcnRhbHMiOltdLCJub3RPblBvcnRhbHNMb2FkIjpbXSwic2VsZWN0ZWRGb3JQb3J0YWxzIjpbXSwicHJlU2VsZWN0ZWRGb3JQb3J0YWxzIjpbXSwib25Qb3J0YWxzTG9hZCI6W10sInBvcnRhbHMiOltdLCJwcm94aW1pdGllcyI6W10sImZlYXR1cmVzIjpbXSwibmVpZ2hib3Job29kcyI6W10sImNpdGllcyI6W10sInN1YnR5cGVzIjpbXSwidHlwZXMiOltdLCJzdGF0dXNlcyI6W10sInB1cnBvc2VzIjpbXSwibmVnb3RpYWJsZSI6MSwiYXBwcm92YWxTdGF0dXMiOjEsImRyYWZ0Ijp0cnVlLCJpIjp0cnVlfQ=='
        return `${base}?q=${encodeURIComponent(query)}`
    }
    return draft ? '/properties/search/draft' : '/properties/search'
}

async function activate () {
    if (state.saving) return false
    state.saving = true
    try {
        await load()
        const { data } = await client.post('Salvando preferência...', '/user/interface-options', { search_version: 2 })
        if (data.search_version !== 2) throw new Error('A nova pesquisa não foi ativada.')
        state.searchVersion = data.search_version
        return true
    } finally {
        state.saving = false
    }
}

module.exports = { state, load, searchUrl, activate }



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/interface-options.js